export default "__VITE_ASSET__C9VNE85z__"